export default __webpack_public_path__ + "static/media/8FT.e427ba74.png";